import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "BasketsWidgetActions";

export const classes = {
  actionsContainer: `${PREFIX}-actionsContainer`,
  searchContainer: `${PREFIX}-searchContainer`,
  orderContainer: `${PREFIX}-orderContainer`,
};

const StyledBasketsWidgetActions = styled(Box)<{ barWidth?: number }>(({ theme, barWidth }) => ({
  display: "grid",
  gridTemplate: "'actions search order' / auto 1fr auto",
  gap: theme.spacing(1),

  [theme.breakpoints.down("md")]: {
    gridTemplate: "'search search' 'actions order'",
  },

  [theme.breakpoints.down("sm")]: {
    gridTemplate: "'search' 'actions' 'order'",
  },

  ...(barWidth &&
    barWidth < theme.breakpoints.values.md && {
      // RF-3322 bugfix when basketLayout is opened
      gridTemplate: "'search search' 'actions order'",
    }),

  [`& .${classes.actionsContainer}`]: {
    gridArea: "actions",
    display: "flex",
    flexDirection: "row",
    button: {
      height: "34px",
    },
  },

  [`& .${classes.searchContainer}`]: {
    gridArea: "search",
    minWidth: theme.spacing(30),
    alignItems: "center",
    "& .MuiFormControl-root .MuiOutlinedInput-root": {
      height: "34px",
    },
  },

  [`& .${classes.orderContainer}`]: {
    gridArea: "order",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& .MuiInput-root": {
      height: "34px",
    },
    "& .MuiBox-root": {
      flexDirection: "row-reverse",
    },
    maxWidth: (theme) => theme.spacing(40),
    justifySelf: "end",
  },
}));

export default StyledBasketsWidgetActions;
